import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityMonitor = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'registration':
        return 'UserPlus';
      case 'booth_visit':
        return 'Store';
      case 'chat':
        return 'MessageSquare';
      case 'video':
        return 'Video';
      case 'approval':
        return 'CheckCircle';
      case 'system':
        return 'Settings';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'registration':
        return 'text-success';
      case 'booth_visit':
        return 'text-primary';
      case 'chat':
        return 'text-secondary';
      case 'video':
        return 'text-accent';
      case 'approval':
        return 'text-success';
      case 'system':
        return 'text-warning';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / 60000);

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return date?.toLocaleDateString();
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Activity" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg font-heading font-semibold text-foreground">
              Live Activity Monitor
            </h3>
            <p className="text-sm text-muted-foreground">Real-time platform events</p>
          </div>
        </div>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {activities?.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12">
            <Icon name="Activity" size={48} color="var(--color-muted-foreground)" />
            <p className="mt-3 text-muted-foreground">No recent activity</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {activities?.map((activity) => (
              <div key={activity?.id} className="p-4 hover:bg-muted/50 transition-smooth">
                <div className="flex gap-3">
                  <div className={`flex-shrink-0 ${getActivityColor(activity?.type)}`}>
                    <Icon name={getActivityIcon(activity?.type)} size={20} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground">
                      {activity?.title}
                    </p>
                    <p className="text-sm text-muted-foreground line-clamp-2 mt-1">
                      {activity?.description}
                    </p>
                    <div className="flex items-center gap-3 mt-2">
                      <span className="text-xs text-muted-foreground data-text">
                        {formatTime(activity?.timestamp)}
                      </span>
                      {activity?.user && (
                        <>
                          <span className="text-xs text-muted-foreground">•</span>
                          <span className="text-xs text-muted-foreground">
                            {activity?.user}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityMonitor;